import { AfterViewInit, Directive, EventEmitter, Output } from '@angular/core'

/**
 * Used in the Dynamic Table to wait for the p-table element to initialize. Only then the width of the DOM element is calculated. The width is then used to calculate initial columns widths of the table
 */
@Directive({
  selector: '[jmlLibInitCallback]'
})
export class InitCallbackDirective implements AfterViewInit {
  @Output() init = new EventEmitter()

  constructor() {}

  ngAfterViewInit() {
    this.init.emit()
  }
}
